import localFont from 'next/font/local';

export const gilroyRegular = localFont({
  src: '../styles/fonts/Gilroy/Gilroy-Regular.woff2',
  weight: '400',
  variable: '--font-gilroy-regular',
  display: 'swap',
});

export const gilroyMedium = localFont({
  src: '../styles/fonts/Gilroy/Gilroy-Medium.woff2',
  weight: '500',
  variable: '--font-gilroy-medium',
  display: 'swap',
});

export const gilroySemiBold = localFont({
  src: '../styles/fonts/Gilroy/Gilroy-Semi-Bold.woff2',
  weight: '600',
  variable: '--font-gilroy-semibold',
  display: 'swap',
});

export const gilroyBold = localFont({
  src: '../styles/fonts/Gilroy/Gilroy-Bold.woff2',
  weight: '700',
  variable: '--font-gilroy-bold',
  display: 'swap',
});

export const gilroyExtraBold = localFont({
  src: '../styles/fonts/Gilroy/Gilroy-Extra-Bold.woff2',
  weight: '800',
  variable: '--font-gilroy-extrabold',
  display: 'swap',
});

export const gilroyBlack = localFont({
  src: '../styles/fonts/Gilroy/Gilroy-Black.woff2',
  weight: '900',
  variable: '--font-gilroy-black',
  display: 'swap',
});

export const robotoRegular = localFont({
  src: '../styles/fonts/Roboto/Roboto-Regular.ttf',
  weight: '400',
  variable: '--font-roboto-regular',
  display: 'swap',
});

export const robotoMedium = localFont({
  src: '../styles/fonts/Roboto/Roboto-Medium.ttf',
  weight: '500',
  variable: '--font-roboto-medium',
  display: 'swap',
});

export const robotoBoldItalic = localFont({
  src: '../styles/fonts/Roboto/Roboto-BoldItalic.ttf',
  weight: '700',
  variable: '--font-roboto-boldItalic',
  display: 'swap',
});

export const robotoBold = localFont({
  src: '../styles/fonts/Roboto/Roboto-Bold.ttf',
  weight: '700',
  variable: '--font-roboto-bold',
  display: 'swap',
});

export const robotoBlack = localFont({
  src: '../styles/fonts/Roboto/Roboto-Black.ttf',
  weight: '900',
  variable: '--font-roboto-black',
  display: 'swap',
});

export const robotoItalic = localFont({
  src: '../styles/fonts/Roboto/Roboto-Italic.ttf',
  weight: '400',
  variable: '--font-roboto-italic',
  display: 'swap',
});

export const robotoLight = localFont({
  src: '../styles/fonts/Roboto/Roboto-Light.ttf',
  weight: '300',
  variable: '--font-roboto-light',
  display: 'swap',
});

export const IBMPlexSansRegular = localFont({
  src: '../styles/fonts/IBMPlexSans/IBMPlexSans-Regular.ttf',
  weight: '400',
  variable: '--font-IBMPlexSans-regular',
  display: 'swap',
});

export const IBMPlexSansMedium = localFont({
  src: '../styles/fonts/IBMPlexSans/IBMPlexSans-Medium.ttf',
  weight: '500',
  variable: '--font-IBMPlexSans-medium',
  display: 'swap',
});

export const IBMPlexSansSemiBold = localFont({
  src: '../styles/fonts/IBMPlexSans/IBMPlexSans-SemiBold.ttf',
  weight: '600',
  variable: '--font-IBMPlexSans-semibold',
  display: 'swap',
});

export const IBMPlexSansBold = localFont({
  src: '../styles/fonts/IBMPlexSans/IBMPlexSans-Bold.ttf',
  weight: '700',
  variable: '--font-IBMPlexSans-bold',
  display: 'swap',
});

export const IBMPlexSansItalic = localFont({
  src: '../styles/fonts/IBMPlexSans/IBMPlexSans-Italic.ttf',
  weight: '400',
  variable: '--font-IBMPlexSans-italic',
  display: 'swap',
});

export const IBMPlexSansLight = localFont({
  src: '../styles/fonts/IBMPlexSans/IBMPlexSans-Light.ttf',
  weight: '300',
  variable: '--font-IBMPlexSans-light',
  display: 'swap',
});
export const IBMPlexSansBoldItalic = localFont({
  src: '../styles/fonts/IBMPlexSans/IBMPlexSans-BoldItalic.ttf',
  weight: '700',
  variable: '--font-IBMPlexSans-boldItalic',
  display: 'swap',
});

export const FONT_VARS = [
  gilroyRegular.variable,
  gilroyMedium.variable,
  gilroySemiBold.variable,
  gilroyBold.variable,
  gilroyExtraBold.variable,
  gilroyBlack.variable,
  robotoLight.variable,
  robotoRegular.variable,
  robotoItalic.variable,
  robotoMedium.variable,
  robotoBold.variable,
  robotoBoldItalic.variable,
  robotoBlack.variable,
  IBMPlexSansLight.variable,
  IBMPlexSansRegular.variable,
  IBMPlexSansItalic.variable,
  IBMPlexSansMedium.variable,
  IBMPlexSansSemiBold.variable,
  IBMPlexSansBold.variable,
  IBMPlexSansBoldItalic.variable,
].join(' ');
